import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
type FinalCtaProps = {
  showUrgency?: boolean;
};
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="bg-mint-800 py-20 sm:py-28" aria-labelledby="cierre-title" data-id="element-66" data-mp="19cun81976qnn">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-67" data-mp="15bspjouximns">
        <Reveal data-id="element-68" data-mp="1jclmeg8pdtu2">
          <h2 id="cierre-title" className="font-display text-3xl leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-69" data-mp="1jc3hkv7z67aj">
            El próximo fin de semana podés seguir buscando información. O podés
            resolver esto desde hoy.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-mint-100" data-id="element-70" data-mp="1o3v6z2fea6z3">
            El problema es el mismo. La solución también.
          </p>
        </Reveal>

        {showUrgency ? <Reveal delay={0.06} className="mt-12" data-id="element-71" data-mp="2219zig0y2uva">
            <CountdownTimer tone="dark" label="LA BONIFICACIÓN CIERRA EN" note="Después sube y no vuelve." data-id="element-72" data-mp="1x5kx84xjizva" />
          </Reveal> : null}

        <Reveal delay={0.08} data-id="element-73" data-mp="n7p6ff23hdkb">
          <div className="mt-12 rounded-3xl bg-white px-8 py-10 sm:px-12" data-id="element-74" data-mp="s4fkjwuc9z33">
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-mint-700" data-id="element-75" data-mp="s6il3at4bam2">
              Pack Completo
            </p>
            <p className="mt-3 text-[15px] text-ink-soft" data-id="element-76" data-mp="123elsucrysg2">
              6 tomos + 15 días de protocolo + 50 recetas + 5 bonos
            </p>
            <p className="mt-5 font-display text-5xl text-ink" data-id="element-77" data-mp="1646thj600pa8">18,99 €</p>
            <div className="mt-7" data-id="element-78" data-mp="1b2i621nohdw5">
              <CtaButton data-id="element-79" data-mp="1b1gs9pfa2daq">Quiero el Megapack</CtaButton>
            </div>
            <p className="mt-5 text-xs text-ink-muted" data-id="element-80" data-mp="1fvkz88ojmlbt">
              El cobro se realiza en la moneda de tu país. Pago 100% seguro ·
              Acceso inmediato · Garantía 7 días sin preguntas.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}